import { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useMember, formatApiError } from "../../lib/memberAuth";

const inp = "w-full border border-black/15 rounded-xl px-4 py-3 text-sm focus:border-[#E63946] outline-none";
const L = ({ children }) => <label className="block text-xs uppercase tracking-[0.18em] text-black/50 mb-2">{children}</label>;
const PREFS = [
  ["announcements", "Email announcements"], ["event_reminders", "Event reminders"],
  ["ministry_notifications", "Ministry notifications"], ["giving_receipts", "Giving receipts"],
  ["order_notifications", "Order notifications"], ["newsletter", "Church newsletter"],
];

export const ProfileSection = () => {
  const { member, setMember } = useMember();
  const [f, setF] = useState({
    name: member.name || "", preferred_name: member.preferred_name || "", phone: member.phone || "",
    address: member.address || "", birthday: member.birthday || "", prefs: { ...(member.prefs || {}) },
  });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/members/profile", f);
      setMember(data);
      toast.success("Profile saved");
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div data-testid="profile-section" className="max-w-xl space-y-5">
      <div className="grid sm:grid-cols-2 gap-4">
        <div><L>Full Name</L><input className={inp} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="profile-name-input" /></div>
        <div><L>Preferred Name</L><input className={inp} value={f.preferred_name} onChange={(e) => setF({ ...f, preferred_name: e.target.value })} /></div>
        <div><L>Phone</L><input className={inp} value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="profile-phone-input" /></div>
        <div><L>Birthday</L><input type="date" className={inp} value={f.birthday} onChange={(e) => setF({ ...f, birthday: e.target.value })} /></div>
        <div className="sm:col-span-2"><L>Address</L><input className={inp} value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} /></div>
      </div>
      <div>
        <L>Communication Preferences</L>
        <div className="grid sm:grid-cols-2 gap-2.5 mt-1">
          {PREFS.map(([k, l]) => (
            <label key={k} className="flex items-center gap-2.5 text-sm text-black/70 cursor-pointer">
              <input type="checkbox" checked={f.prefs[k] !== false} onChange={(e) => setF({ ...f, prefs: { ...f.prefs, [k]: e.target.checked } })} className="w-4 h-4 accent-[#E63946]" />
              {l}
            </label>
          ))}
        </div>
      </div>
      <p className="text-xs text-black/40">Email: {member.email} (used to link your giving, tickets and orders — contact the church office to change it). Your personal information is never publicly displayed.</p>
      <button onClick={save} disabled={busy} data-testid="save-profile-btn"
        className="rounded-full bg-[#E63946] text-white px-8 py-3.5 font-medium hover:bg-[#BA1B25] transition-colors disabled:opacity-60">
        {busy ? "Saving…" : "Save Profile"}
      </button>
    </div>
  );
};
